export enum OrderSelectionColumns {
  Number = 'orderNumber',
  Name = 'orderName',
  Description = 'orderDescription',
  CustomerNumber = 'customerNumber',
  CustomerName = 'customerName',
}
